import { Injectable } from '@angular/core';
import { ModeModelBase } from '../model';
import { ModelAccessorBase, ModelAccessorInjectables } from '../model_accessor';

export class DataSourceTableModel extends ModeModelBase {
  override _name = 'dataSourceTable';
  override belongsTo = 'dataSource';
  override parentIdAttribute = 'token';
  override attributes = [
    { name: 'name', default: '' },
    { name: 'schema', default: '' },
    { name: 'dataSourceId', default: '' },
    { name: 'dataSource', default: '' },
    { name: 'description', default: '' },
    { name: 'created_at', default: '' },
  ];
  override hasOne = [{ name: 'preview', idAttribute: 'id' }];
}

@Injectable({ providedIn: 'root' })
export class DataSourceTableModelAccessor extends ModelAccessorBase<DataSourceTableModel> {
  override name = 'dataSourceTable';
  override parentModel = 'dataSource';
  override parentIdAttribute = 'token';
  override createModel(resource, opts?) {
    const model = new DataSourceTableModel(this.injectables.modelInjectables);
    model.$initialize(resource, opts);
    return model;
  }
  constructor(injectables: ModelAccessorInjectables) {
    super(injectables, 'migrated', 'mode.dataSourceTable');
  }
}
